<template>
    <div ref="chartContainer" style="height: 100%; width: 100%"></div>
  </template>
  
  <script setup>
  import { ref, onMounted, watch } from 'vue';
  import Highcharts from 'highcharts';
  import loadFunnel from "highcharts/modules/funnel";

loadFunnel(Highcharts);
  
  const props = defineProps({
    data: {
      type: Array,
      required: true,
      default: () => [200, 300, 400, 500, 450, 600, 550, 700, 800],
    },
    categories: {
      type: Array,
      default: () => ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
    },
  });
  
  const chartContainer = ref(null);
  let chartInstance = null;
  
  const initChart = () => {
    if (chartInstance) chartInstance.destroy();
  
    chartInstance = Highcharts.chart(chartContainer.value, {
      chart: {
        type: 'areaspline',
        backgroundColor: 'transparent',
      },
      title: { text: '' },
      xAxis: {
        categories: props.categories,
        gridLineWidth: 0,
        labels: { style: { color: '#555' } },
      },
      yAxis: {
        title: { text: '' },
        gridLineDashStyle: 'ShortDash',
        labels: { style: { color: '#555' } },
      },
      tooltip: {
        shared: true,
        valuePrefix: '₦',
      },
      series: [
        {
          name: 'Giving',
          data: props.data,
          color: '#007bff',
          fillOpacity: 0.2,
          marker: {
            enabled: true,
            radius: 4,
          },
        },
      ],
      credits: { enabled: false },
      legend: { enabled: false },
    });
  };
  
  onMounted(initChart);
  watch(() => props.data, initChart);
  </script>
  